<template>
  <modal :name="modalName" class="confirmModal" :height="'auto'" :width="'400px'">
    <div class="confirm-wrapper">
      <p class="message">{{ message }}</p>
      <div class="actions">
        <button type="button" class="button ghost" @click="onCancel">
          {{ cancelText }}
        </button>
        <button type="button" class="button danger" @click="onConfirm">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: "ConfirmModal",
  props: {
    message: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: "Sim"
    },
    cancelText: {
      type: String,
      default: "Não"
    },
    modalName: {
      type: String,
      default: "feedbackConfirmModal"
    },
  },
  methods: {
    open() {
      this.$modal.show(this.modalName);
    },
    close() {
      this.$modal.hide(this.modalName);
    },
    onConfirm() {
      this.$emit("confirm");
      this.close();
    },
    onCancel() {
      this.$emit("cancel");
      this.close();
    }
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../../assets/variables.less");

.confirm-wrapper {
  width: calc(100% - 40px);
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.message {
  margin: 0;
  font-size: 1rem;
  color: #333;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.button {
  min-width: 100px;
  padding: 6px 14px;
  margin: 0;
}

.ghost {
  background-color: white;
  box-shadow: none;
  color: #dc143d;
  border: 1px solid #dc143d;

  &:hover {
    color: #212146;
    border: 1px solid #212146;
  }
}

.danger {
  background: #dc143d;
  color: #fff;
  border: 1px solid #dc143d;

  &:hover {
    background: #b01030;
    border-color: #b01030;
  }
}
</style>
